import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {ListVentasComercioComponent} from "./list-ventas-comercio/list-ventas-comercio.component";



const routes: Routes = [
  {
    path: '',
    component: ListVentasComercioComponent,
    pathMatch: 'full'
  },
];
@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VentasComercioRoutingModule { }
